export const STEPS = [
  { label: "Select Plan" },
  { label: "Add-ons" },
  { label: "School Details" },
  { label: "Review & Pay" },
];

export const getSlabPrice = (plan, slabId) => {
  const slab = plan.slabs.find((s) => s.id === slabId);
  return slab ? slab.price.split("/")[0] : "";
};

export const CUSTOM_PLAN = {
  title: "Build Your Custom Plan",
  description:
    "Tailor a plan to your school's specific needs. Choose the features you want, scale by users, and get a quote that fits your budget.",
  includes: [
    "Unlimited Features",
    "Unlimited Cloud Storage",
    "24/7 support for all issues",
  ],
  ctaText: "Contact Sales",
};

export const formatCurrency = (amount) =>
  `₹${Number(amount || 0).toLocaleString("en-IN")}`;

export const SCHOOL_BOARD_OPTIONS = [
  { value: 2, label: "Tamil Nadu State Board" },
  { value: 1, label: "CBSE" },
  { value: 3, label: "ICSE" },
  { value: 4, label: "NIOS" },
];

export const SCHOOL_CATEGORY_OPTIONS = [
  { value: 283, label: "Primary (Class LKG to 5)" },
  { value: 284, label: "Primary (Class 1 to 5)" },
  { value: 285, label: "Nursery Class (LKG, UKG only)" },
  { value: 286, label: "High Secondary (Class 1 to 12)" },
  { value: 287, label: "High Secondary (Class 6 to 12)" },
];

export const INITIAL_SCHOOL_DETAILS = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  schoolName: "",
  schoolBoard: null,
  schoolCategory: null,
  city: null,
  state: null,
  pincode: "",
  address: "",
  udiseCode: "",
  gstin: "",
  sameAsOrganization: true,
  adminFirstName: "",
  adminLastName: "",
  adminEmail: "",
  adminPhone: "",
  shortNameUrl: "",
  emailVerified: false,
  // JWT returned by saas/send-email-verification once the OTP is confirmed
  emailVerifiedToken: "",
  shortNameVerified: false,
  agreedToTerms: false,
};
